import { ProfileGetResponse } from 'const/syfApiQueries'
import { NotificationAccount } from '../typings/notifications'

const getAccountsForEmailUpdate = (
  allProfileResponseData: ProfileGetResponse[]
) => {
  const accounts: NotificationAccount[] = []

  allProfileResponseData.forEach((profileData) => {
    const shouldUpdateEmail = profileData?.profile?.updateEmail === true

    if (shouldUpdateEmail) {
      accounts.push({
        accountId: profileData?.accountId,
        accountName: profileData?.accountName
      })
    }
  })

  return accounts
}

export default getAccountsForEmailUpdate
